import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../models/user';

@Component({
  selector: 'app-login',
  templateUrl: './support-login.component.html',
  styleUrls: ['./support-login.component.css']
})
export class SupportLoginComponent implements OnInit {

  api_error: any;
  loginId = '';
  password = '';
  secondPassword;
  constructor(
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private user: User
  ) { }

  ngOnInit() {
     // reset login status
     //this.authenticationService.logout();


  }

  login(loginForm: NgForm) {
   this.user.loginId = loginForm.value.loginId;
   this.user.password = loginForm.value.password;
   this.user.secondPassword = loginForm.value.secondPassword;

    this.authenticationService.support_login(this.user)
     .subscribe(

        data => {
          // alert('vxgvd');
          setTimeout(() => {
            this.router.navigate(['home/dashboard']);
            }, 500);
          },
       (error) => {
        this.api_error = error.error;
        }
      );





  }

}
